"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttrService = void 0;
var AttrService = /** @class */ (function () {
    function AttrService() {
    }
    AttrService.prototype.data = function (el, attr) {
        var data = el.data(attr);
        el.removeAttr("data-".concat(attr));
        return data;
    };
    AttrService.prototype.attr = function (el, attr) {
        var data = el.attr(attr);
        el.removeAttr(attr);
        return data;
    };
    return AttrService;
}());
var service = new AttrService();
exports.AttrService = service;
